module.exports = __webpack_public_path__ + "static/media/school-icon--green.6d7cb52e.svg";